import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { share } from 'rxjs/operators';
import { SpinnerService } from './spinner.service';
import { AppSettings } from '../app.settings';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    // let headers

    constructor(private http: HttpClient,
        private appSettings: AppSettings,
        private spinnerService: SpinnerService,
        ) {}

    GetHeaders(): HttpHeaders {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        // headers.append('UserID', this.storage.UserID);
        // headers.append('ADUserName', this.storage.ADUserName);
        return headers;
    }
    get<T>(url: string, options?: any, spinnerMessage?: string): Observable<T> {
        this.activateSpinnerMessage(spinnerMessage);
        return this.http.get<T>(this.appSettings.Packaging2APIUrl + url)
        .pipe(share());
    }

    getExternal<T>(url: string, options?: any, spinnerMessage?: string): Observable<T> {
        this.activateSpinnerMessage(spinnerMessage);
        return this.http.get<T>(url)
        .pipe(share());
    }

    getAll<T>(url: string, spinnerMessage?: string): Observable<T[]> {
        this.activateSpinnerMessage(spinnerMessage);
        return this.http.get<T[]>(this.appSettings.Packaging2APIUrl + url).pipe(
            share()
        );
    }
    post(url: string, body: any | null, options?: any, spinnerMessage?: string) {
        this.activateSpinnerMessage(spinnerMessage);
        return this.http.post(this.appSettings.Packaging2APIUrl + url, body, options);
    }
    put(url: string, body: any | null, options?: any, spinnerMessage?: string) {
        this.activateSpinnerMessage(spinnerMessage);
        return this.http.put(this.appSettings.Packaging2APIUrl + url, body, options);
    }
    delete(url: string, options?: any, spinnerMessage?: string) {
        this.activateSpinnerMessage(spinnerMessage);
        return this.http.delete(this.appSettings.Packaging2APIUrl + url, options);
    }
    activateSpinnerMessage(spinnerMessage?: string) {
        if (spinnerMessage) {
            this.spinnerService.RefreshspinnerMessage(spinnerMessage);
        }

    }
}
